module.exports = __webpack_public_path__ + "static/media/elements-web-logo-white.79d9add2.svg";